import Svg, { Path } from 'react-native-svg';
import React from 'react';
import { Flex } from '@banhala/ui-kit';

export const ScrollToBottomButton: React.FC<{
  testID: string;
  onPress: () => void;
}> = props => {
  return (
    <Flex
      testID={props.testID}
      onPress={props.onPress}
      width={40}
      height={40}
      borderRadius={40}
      backgroundColor={'bg_always_white'}
    >
      <Svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.1677 14.2879V23.5963L15.101 19.5296C14.776 19.2046 14.2427 19.2046 13.9177 19.5296C13.5927 19.8546 13.5927 20.3796 13.9177 20.7046L19.4094 26.1963C19.7344 26.5213 20.2594 26.5213 20.5844 26.1963L26.0844 20.7129C26.4094 20.3879 26.4094 19.8629 26.0844 19.5379C25.7594 19.2129 25.2344 19.2129 24.9094 19.5379L20.8344 23.5963V14.2879C20.8344 13.8296 20.4594 13.4546 20.001 13.4546C19.5427 13.4546 19.1677 13.8296 19.1677 14.2879Z"
          fill="#9E9E9E"
        />
      </Svg>
    </Flex>
  );
};
